export enum VaultStatus {
  ACTIVE = "ACTIVE",
  ACTIVE_REWARDS = "ACTIVE_REWARDS",
  DEPRECATED = "DEPRECATED",
}
